import { z } from 'zod/v4';
import { IncomingState, OutgoingState } from '../../interactions/index.js';
export const interactionStateSchema = z.union([
    z.enum(IncomingState),
    z.enum(OutgoingState),
]);
//# sourceMappingURL=interaction-shape.js.map